import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GraphAnnotationModel } from '../../../core/api/models';
import { graphAnnotationDisplayLabel } from '../../graphs-base.component';

@Component({
  selector: 'app-annotation-display-panel',
  templateUrl: './annotation-display-panel.component.html',
  standalone: false,
})
export class AnnotationDisplayPanelComponent {
  @Input() annotations: GraphAnnotationModel[] = [];
  @Input() displayAnnotations = true;
  @Input() displayAutomaticAnnotations = true;
  @Input() displayUserAnnotations = true;
  @Input() canAddAnnotation = false;
  @Input() isAnnotationDisplayed: (annotation: GraphAnnotationModel) => boolean = () => true;

  @Output() displayAnnotationsChange = new EventEmitter<boolean>();
  @Output() displayAutomaticAnnotationsChange = new EventEmitter<boolean>();
  @Output() displayUserAnnotationsChange = new EventEmitter<boolean>();
  @Output() annotationDisplayChange = new EventEmitter<{ annotation: GraphAnnotationModel; isDisplayed: boolean }>();
  @Output() addAnnotation = new EventEmitter<void>();
  @Output() editAnnotation = new EventEmitter<GraphAnnotationModel>();

  automaticAnnotations() {
    return this.annotations.filter((annotation) => annotation.IsAutomatic);
  }

  userAnnotations() {
    return this.annotations.filter((annotation) => !annotation.IsAutomatic);
  }

  annotationLabel(annotation: GraphAnnotationModel): string {
    return graphAnnotationDisplayLabel(annotation);
  }

  onAnnotationDisplayChange(annotation: GraphAnnotationModel, isDisplayed: boolean) {
    this.annotationDisplayChange.emit({ annotation, isDisplayed });
  }
}
